var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vip-center-entrance-component",on:{"click":_vm.handleClick}},[_c('ym-img',{staticClass:"icon-vip",attrs:{"src":require('@/assets/img/vip/vip_round_icon.png'),"alt":"会员中心"}}),_vm._v("\n  会员中心\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }